<div class="timing-warning"
     *ngIf="mode !== 'overview'">
  Please keep in mind that once participants starts answering this module you will not be able to edit the ESM timing rule anymore!
</div>
<div class="calender-buttons">
  <div class="view-toggle-buttons">
    <button *ngIf="mode !== 'overview'" [class.active]="monthView" (click)="changeCalendarView('month')">
      Month
    </button>
    <button *ngIf="mode !== 'overview'" [class.active]="weekView" (click)="changeCalendarView('week')">
      Week
    </button>
  </div>
  <div>
    <div *ngIf="isRelativeTriggerType"
         class="start-date-time">
      <div>
        Participant started at:
      </div>
      <div>
        <mat-form-field>
          <input matInput
                 type="date"
                 placeholder="Start Date"
                 [(ngModel)]="participantStartDay"
                 (ngModelChange)="onParticipantStartDayChange()">
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="clear-calender" *ngIf="mode !== 'overview'">
    <button class="clear-button" (click)="clearCalender()">
      Clear calender
    </button>
  </div>
</div>
<div class="calendar-header">
  <button class="left-button"
          (click)="navigateCalendar(-1)">
    <
  </button>
  <div class="month-display"> {{ getMonthDisplay() }}
  </div>
  <button class="right-button"
          (click)="navigateCalendar(1)">
    >
  </button>
</div>
<div *ngIf="monthView">
  <mwl-calendar-month-view
    [viewDate]="viewDate"
    [events]="events"
    (dayClicked)="openPlannerDialog($event.day, 'month')"
    [cellTemplate]="customMonthCellTemplate">
  </mwl-calendar-month-view>
</div>
<div *ngIf="weekView">
  <mwl-calendar-week-view
    [viewDate]="viewDate"
    [events]="events"
    (hourSegmentClicked)="openPlannerDialog($event.date, 'week')"
    [headerTemplate]="customHeaderTemplate"
    [eventTitleTemplate]="customWeekEventTitleTemplate">
  </mwl-calendar-week-view>
</div>

<div class="events-tooltip" *ngIf="showMoreEvents">
  <div class="header">
    <div>
    </div>
    <div>
      <div class="header-day">{{ day.events[0].start | date: 'E' }}</div>
      <div class="header-date">{{ day.events[0].start | date: 'd' }}</div>
    </div>
    <button class="close close-more-popup" (click)="toggleShowMore(day)">&times;</button>
  </div>
  <div class="container-custom-event">
    <div *ngFor="let event of day.events"
         class="custom-event"
         [ngStyle]="{ 'background-color': event.color.primary }">
      <div (click)="openEventPlannerDialog(event)">
        <b *ngIf="event.title">{{ event.title }}:</b> {{ event.start | date: 'HH:mm' }}
        to {{ event.end | date: 'HH:mm' }}
        <mat-spinner *ngIf="loadEventDetails" color="accent" [diameter]="14" [strokeWidth]="2"></mat-spinner>
      </div>
    </div>
  </div>
</div>

<ng-template #customMonthCellTemplate
             let-day="day"
             let-locale="locale"
             let-tooltipPlacement="tooltipPlacement"
             let-highlightDay="highlightDay"
             let-unhighlightDay="unhighlightDay"
             let-eventClicked="eventClicked"
             let-tooltipTemplate="tooltipTemplate"
             let-tooltipAppendToBody="tooltipAppendToBody"
             let-tooltipDelay="tooltipDelay">
  <div class="cal-cell-top">
    <span class="cal-day-badge"
          *ngIf="isStartDay(day.date) && triggerType === 'esm_relative_date'">
      Start
    </span>
    <span class="cal-day-badge" *ngIf="day.badgeTotal > 0">
      {{ day.badgeTotal }}
    </span>
    <span class="cal-day-number">
      {{ day.date | calendarDate:'monthViewDayNumber':locale }}
    </span>
  </div>
  <div *ngIf="day.events.length > 0">
    <div *ngFor="let event of day.events; index as i">
      <ng-template *ngIf="i < 2; then showEventsBlock; else showMoreBlock">
      </ng-template>
      <ng-template #showEventsBlock>
        <div class="custom-event"
             *ngIf="i < 2"
             [ngStyle]="{ backgroundColor: event.color?.primary }"
             [ngClass]="event?.cssClass"
             (click)="openEventPlannerDialog(event)"
             (mwlClick)="eventClicked.emit({event: event})"
             [mwlCalendarTooltip]="event.title | calendarEventTitle: 'monthTooltip':event"
             [tooltipPlacement]="tooltipPlacement"
             [tooltipEvent]="event"
             [tooltipTemplate]="tooltipTemplate"
             [tooltipAppendToBody]="tooltipAppendToBody"
             [tooltipDelay]="tooltipDelay">
          <b *ngIf="event.title">{{ event.title }}:</b> {{ event.start | date: 'HH:mm' }} to {{ event.end | date: 'HH:mm' }}
          <mat-spinner *ngIf="loadEventDetails" color="accent" [diameter]="14" [strokeWidth]="2"></mat-spinner>
        </div>
      </ng-template>
      <ng-template #showMoreBlock>
        <ng-container *ngIf="i === 2">
          <div class="cal-show-more-events"
               (click)="toggleShowMore(day)"
               (mwlClick)="eventClicked.emit({event: event})">
            <a> {{day.events.length - 2}} more</a>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #customHeaderTemplate let-days="days" let-locale="locale">
  <div class="cal-day-headers cursor-default">
    <div
      class="cal-header"
      *ngFor="let day of days">
      <div class="top">
        <div class="day-label text-uppercase">
          {{ day.date | calendarDate:'weekViewColumnHeader':locale }}
        </div>
        <span class="cal-day-number">{{ day.date | calendarDate:'weekViewColumnSubHeader':locale }}</span>
      </div>
      <div class="cal-day-badge"
           *ngIf="isStartDay(day.date) && triggerType === 'esm_relative_date'">
        Start
      </div>
    </div>
  </div>
</ng-template>

<ng-template #customWeekEventTitleTemplate
             let-day="day"
             let-event="event">
  <div class="custom-event"
       (click)="openEventPlannerDialog(event)">
    <b *ngIf="event.title">{{ event.title }}:</b> {{ event.start | date: 'HH:mm' }} to {{ event.end | date: 'HH:mm' }}
    <mat-spinner *ngIf="loadEventDetails" color="accent" [diameter]="14" [strokeWidth]="2"></mat-spinner>
  </div>
</ng-template>
